<h5>{{ 'Candidates' | translate }}</h5>

<div class="row mb-4 align-items-center">
  <div class="col-md-8">
    <div class="_buttons">
      <button type="button" class="btn btn-primary shadow-sm me-2" (click)="openModal()">
        <i class="fa fa-plus"></i>&nbsp;{{ 'New Candidate' | translate }}
      </button>
    </div>
  </div>
  <div class="col-md-4">
    <div class="input-group">
      <input type="text" class="form-control shadow-sm" placeholder="{{ 'Search...' | translate }}" [(ngModel)]="searchText" (input)="applyFilter()">
      <button class="btn btn-secondary shadow-sm" type="button" (click)="clearSearch()">{{ 'Clear' | translate }}</button>
    </div>
  </div>
</div>

<div class="card-container">
  <div class="row">
    <ng-container *ngIf="candidates.length > 0; else noDataFound">
      <div class="col-md-6 col-lg-4 mb-4" *ngFor="let candidate of filteredCandidates | slice: (page-1)*pageSize : page*pageSize">
        <div class="candidate-card">
          <div class="card-body">
            <h5 class="card-title">{{ candidate.name }}</h5>
            <p class="card-text">
              <i class="fa fa-envelope"></i> {{ candidate.email }}
            </p>
            <p class="card-text">
              <i class="fa fa-phone"></i> {{ candidate.phone }}
            </p>
            <a *ngIf="candidate.document" class="btn btn-link" [href]="candidate.document?.url" target="_blank">
              <i class="fa fa-file"></i> {{ 'Open File' | translate }}
            </a>
          </div>
          <div class="card-footer">
            <div class="action-buttons">
              <button (click)="deleteCandidate(candidate)" class="action-button action-button-delete">
                <i class="fa fa-trash"></i> {{ 'Delete' | translate }}
              </button>
              <button (click)="openModal(candidate)" class="action-button action-button-edit">
                <i class="fa fa-edit"></i> {{ 'Edit' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #noDataFound>
      <div class="col-12 text-center">
        <p class="text-muted">{{ 'No data found.' | translate }}</p>
      </div>
    </ng-template>
  </div>

  <!-- Pagination -->
  <div class="mt-3 d-flex justify-content-end">
    <ngb-pagination 
      class="shadow-sm"
      [(page)]="page" 
      [pageSize]="pageSize" 
      [collectionSize]="totalItems" 
      (pageChange)="pageChange($event)">
    </ngb-pagination>
  </div>
</div>
